/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */
import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import DocumentTitle from 'react-document-title';

import {SetLocalStorageValue, GetLocalStorageValue, RDVR_STATES} from '../utils';
import Tooltip from 'rc-tooltip';
import Translate from '../components/Translate';

import ShowcaseNotifications from '../containers/ShowcaseNotifications';

import moment from 'moment';
import _get from 'lodash/get';
import _reverse from 'lodash/reverse';
import _sortBy from 'lodash/sortBy';
import _map from 'lodash/map';

import _orderBy from 'lodash/orderBy';
import _groupBy from 'lodash/groupBy';
import _debounce from 'lodash/debounce';

class NotificationsRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTermInput: '',
      searchTerm: '',
      filterBy: GetLocalStorageValue('notifications-filter-sort', ['date', 'desc']),
      filters: ['date', 'alphabet', 'channel'],
      notifications: [],
      channelIds: []
    };

    this._setSearchTerm = _debounce(this._setSearchTerm.bind(this), 350);
  }

  componentDidMount() {

    document.getElementById('notifications-search') && document.getElementById('notifications-search').focus();

    let newState = {};

    newState.notifications = _get(this.props, 'notifications', []).map((notification) => {
      notification.type = 'notification';
      notification._date = moment.unix(notification.start).format('YYYYMMDD');
      notification._letter = _get(notification, 'program.title', '#')[0];

      return notification;
    });

    this.setState(newState);
  }

  componentWillReceiveProps(newPros) {
    let newState = {};

    newState.notifications = _get(newPros, 'notifications', []).map((notification) => {
      notification.type = 'notification';
      notification._date = moment.unix(notification.start).format('YYYYMMDD');
      notification._letter = _get(notification, 'program.title', '#')[0];

      return notification;
    });

    this.setState(newState);
  }

  _onSearchTermChange(event = {}) {

    this.setState({searchTermInput: _get(event, 'target.value', '')});
    this._setSearchTerm(_get(event, 'target.value', ''));
  }

  _setSearchTerm(text) {

    this.setState({searchTerm: text});
  }

  _setFilter(filter) {
    let filters = [filter];

    if (filter === this.state.filterBy[0]) {

      if (this.state.filterBy[1] === 'asc') filters.push('desc');
      if (this.state.filterBy[1] === 'desc') filters.push('asc');
    } else {

      filters.push(filter === 'date' ? 'desc' : 'asc');
    }

    SetLocalStorageValue('notifications-filter-sort', filters);

    this.setState({
      filterBy: filters
    })
  }

  __renderFilter(type) {
    switch (type) {
      case 'date': {

        return (
          <span className="switcher-icon">
            <i className="ic ic-calendar-clock ic-24px"></i>
            {type === this.state.filterBy[0] && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
              <i className="ic ic-selected-dot ic-10px selected-icon"></i>
            </ReactCSSTransitionGroup>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' && <i className="ic ic-sort-asc ic-10px sort-icon"></i>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' && <i className="ic ic-sort-desc ic-10px sort-icon"></i>}
          </span>);
      }

      case 'alphabet': {

        return (
          <span className="switcher-icon">
            <i className="ic ic-abc ic-24px"></i>
            {type === this.state.filterBy[0] && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
              <i className="ic ic-selected-dot ic-10px selected-icon"></i>
            </ReactCSSTransitionGroup>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' && <i className="ic ic-sort-asc ic-10px sort-icon"></i>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' && <i className="ic ic-sort-desc ic-10px sort-icon"></i>}
          </span>);
      }

      case 'channel': {

        return (
          <span className="switcher-icon">
            <i className="ic ic-channel ic-24px"></i>
            {type === this.state.filterBy[0] && <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true} transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
              <i className="ic ic-selected-dot ic-10px selected-icon"></i>
            </ReactCSSTransitionGroup>}
            {/*{type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' && <i className="ic ic-sort-asc ic-10px sort-icon"></i>}*/}
            {/*{type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' && <i className="ic ic-sort-desc ic-10px sort-icon"></i>}*/}
          </span>);
      }

      default: {

        return null;
      }
    }
  }

  _renderFilters() {
    let filters = this.state.filters;

    return filters.map((filter) => {

      return (
        <li key={filter} className="h-rmenu-col block radius bg-black" onClick={this._setFilter.bind(this, filter)}>
          <Tooltip
            placement="top"
            destroyTooltipOnHide={true}
            overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
              <Translate content={`npvr.filters.${filter}`} />
            </div>}>
            <a href="javascript:void(0)" className="hover">
              {this.__renderFilter(filter)}
            </a>
          </Tooltip>
        </li>
      );
    });
  }

  _renderRecords() {
    let type = this.state.filterBy[0];
    let notifications = _get(this.state, 'notifications', []).filter((notification) => {

      return !this.state.searchTerm
        || (_get(notification, 'epg_program.title', '').toLowerCase().indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1)
        || (_get(notification, 'title', '').toLowerCase().indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1)
        || (_get(notification, 'epg_program.description', '').toLowerCase().indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1);
    });

    switch (this.state.filterBy[0]) {
      case 'status':

        notifications = _sortBy(_map(_groupBy(notifications, 'state'), (v, k) => [k, v]), 0);

        if (this.state.filterBy[1] === 'desc') {

          notifications = _reverse(notifications);
        }

        return _map(notifications, function (pairs, index) {

          return <ShowcaseNotifications key={'notifications_' + pairs[0] + '_' + index} id={'notifications_' + pairs[0] + '_' + index} type={type} meta={{title: STATE_TO_TITLE[pairs[0]]}} notifications={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start', 'asc'])} />;
        });

      case 'date':
        notifications = _sortBy(_map(_groupBy(notifications, '_date'), (v, k) => [k, v]), 0);

        if (this.state.filterBy[1] === 'desc') {

          notifications = _reverse(notifications);
        }

        return _map(notifications, function (pairs, index) {
          let title = moment(pairs[0], "YYYYMMDD");

          return <ShowcaseNotifications key={'notifications_' + pairs[0] + '_' + index} id={'notifications_' + pairs[0] + '_' + index} type={type} meta={{title: title}} notifications={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start', 'asc'])} />;
        });

        return [];

      case 'alphabet':
        notifications = _sortBy(_map(_groupBy(notifications, '_letter'), (v, k) => [k, v]), 0);

        if (this.state.filterBy[1] === 'desc') {

          notifications = _reverse(notifications);
        }

        return _map(notifications, function (pairs, index) {

          return <ShowcaseNotifications key={'notifications_' + pairs[0] + '_' + index} id={'notifications_' + pairs[0] + '_' + index} type={type} meta={{title: pairs[0].toUpperCase()}} notifications={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start', 'asc'])} />;
        });

        return [];

      case 'channel':
        notifications = _sortBy(_map(_groupBy(notifications, 'channel_id'), (v, k) => [k, v]), 0);

        //if (this.state.filterBy[1] === 'desc') {
        //
        //  notifications = _reverse(notifications);
        //}

        return _map(notifications, function (pairs, index) {

          return <ShowcaseNotifications key={'notifications_' + pairs[0] + '_' + index} id={'notifications_' + pairs[0] + '_' + index} type={type} meta={{channel_id: pairs[0]}} notifications={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start', 'asc'])} />;
        });

        return [];

      default:

        return <ShowcaseNotifications key={'notifications_all'} id={'notifications_all'} type={'default'} meta={{title: 'All'}} notifications={_orderBy(notifications, ['schedule_time', 'asc'], ['start', 'asc'])} />;
    }

  }

  render() {

    return (<DocumentTitle title={Translate.translator('page.notifications')}>
      <div className="notifications-showcase">
        <div className="blocks-row clearfix">
          <ul className="h-rmenu menu block col-last">
            <li className="h-rmenu-col block radius bg-black search-open">
              <a className="h-rmenu-search-link hover pointer" style={{left: 0}}>
                <i className="ic ic-search-rev ic-24px"></i>
              </a>
              <form className="h-rmenu-search-active __active" style={{left: '63px'}}>
                <input autoFocus type="text" placeholder="Keywords" id="npvr-search"
                       onChange={this._onSearchTermChange.bind(this)}
                       value={this.state.searchTermInput}
                />
                <a href="javascript:void(0)" className="mw-show pad-lr hover">
                  <span className="block-note"></span>
                </a>
              </form>
            </li>
            {this._renderFilters()}
          </ul>
        </div>
        {this._renderRecords()}
        {!this.state.notifications.length && <div id="showcase-empty-container">
          <div className="ui dimmer visible active radius">
            <div className="content">
              <div className="center">
                <h2 className="ui inverted icon header">
                  <Translate content="empty_section" />
                </h2>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </DocumentTitle>);
  }
}

NotificationsRoute.propTypes = {
  notifications: PropTypes.array
};

const mapStateToProps = ({notifications: {notifications}}, ownProps) => {

  return {
    notifications: _get(notifications, 'collection', [])
  };
};

export default connect(mapStateToProps)(NotificationsRoute)


// WEBPACK FOOTER //
// ./src/routes/notifications-route.js